import React, { useState } from 'react';
import { openChat } from '../../../store/actions/chat';
import { connect } from 'react-redux';
import { packageOFF, packageON } from '../../../api/channels';
import { selectHostname } from '~/src/store/selectors/domain';

import {
    Wrapper,
    Title,
    Description,
    ButtonWrapper,
    Button,
    ButtonPink,
    Icon,
    CenterBlock,
    Text,
} from './styled';

import IconSuccess from '../success.svg';
import IconError from '../sad.svg';
const pad = (n) => (`0${n}`).slice(-2);

const ResumptionControl = ({ data, onClose, onSuccess, openChat, auth: { clientPersonal, accessToken }, billingHost }) => {
    const [stateForm, stateFormSetter] = useState({
        errorCode: '',
        isSuccess: false,
        action: data.action,
    });

    let dateToString = '';
    if (data.state.unsetFrom !== null) {
        const dTo = new Date(data.state.unsetFrom * 1000);
        dateToString = `${pad(dTo.getDate())}.${pad(dTo.getMonth() + 1)}.${dTo.getFullYear()}`;
    }

    const onErrorClick = () => {
        onClose();
        openChat();
    };

    const onOffClick = async() => {
        try {
            const result = await packageOFF({
                billingHost: billingHost,
                agreement_id: clientPersonal.agreementId,
                access_token: accessToken,
                tr_id: data.terminalId,
                packet: data.id,
                date_to: dateToString,
            });

            if (Number(result.status) !== 1) {
                stateFormSetter((prev) => ({
                    ...prev,
                    errorCode: result.errorCode,
                    isSuccess: false,
                }));
            } else {
                onSuccess();
                stateFormSetter((prev) => ({
                    ...prev,
                    errorCode: '',
                    isSuccess: true,
                }));
            }
        } catch (e) {
            stateFormSetter((prev) => ({
                ...prev,
                errorCode: 'Error',
                isSuccess: false,
            }));
        }
    };

    const onOnClick = async() => {
        let date_from = undefined;
        if (data.state.dateTo !== null) {
            const dFrom = new Date(data.state.dateTo * 1000);
            date_from = `${pad(dFrom.getDate())}.${pad(dFrom.getMonth() + 1)}.${dFrom.getFullYear()}`;
        }

        try {
            const result = await packageON({
                billingHost: billingHost,
                access_token: accessToken,
                packet: data.id,
                tr_id: data.terminalId,
                date_from,
            });
            if (Number(result.status) !== 1) {
                stateFormSetter((prev) => ({
                    ...prev,
                    errorCode: result.errorCode,
                    isSuccess: false,
                }));
            } else {
                onSuccess();
                stateFormSetter((prev) => ({
                    ...prev,
                    errorCode: '',
                    isSuccess: true,
                }));
            }
        } catch (e) {
            stateFormSetter((prev) => ({
                ...prev,
                errorCode: 'Error',
                isSuccess: false,
            }));
        }
    };

    let content = (
        <React.Fragment>
            <Title> Возобновите пакет каналов </Title>
            <Description> Пакет приостановлен, возобновите его при необходимости </Description>
            <ButtonWrapper>
                <Button type='primary' text='Возобновить' onClick={() => {
 stateFormSetter((prev) => ({
                        ...prev,
                        action: 'on',
                    }));
}}/>
                <ButtonPink type='primary' text='Отключить пакет' onClick={() =>{
 stateFormSetter((prev) => ({
                        ...prev,
                        action: 'off',
                    }));
}}/>
            </ButtonWrapper>
        </React.Fragment>
    );

    if (stateForm.action === 'on') {
        const textEnd = (dateToString !== '') ? `Дата отключения пакета ${dateToString}` : '';
        content = (
            <React.Fragment>
                <Title>Подтвердите возобновление пакета каналов</Title>
                <Text>{`Вы хотите возобновить пакет каналов «${data.name}». ${textEnd}`}</Text>
                <ButtonWrapper>
                    <Button type='primary' text='Подтвердить' onClick={onOnClick}/>
                </ButtonWrapper>
            </React.Fragment>
        );
    }

    if (stateForm.action === 'off') {
        const textEnd = (dateToString !== '') ? `Дата отключения пакета ${dateToString}` : '';

        content = (
            <React.Fragment>
                <Title>Подтвердите заявку на отключение</Title>
                <Text>{`Вы хотите отключить пакет каналов «${data.name}». ${textEnd}`}</Text>
                <ButtonWrapper>
                    <Button type='primary' text='Подтвердить' onClick={onOffClick}/>
                </ButtonWrapper>
            </React.Fragment>
        );
    }

    if (stateForm.errorCode !== '') {
        let errorText = '';
        if (stateForm.action === 'off') {
            errorText = 'Возникла ошибка при отключении пакета каналов. Напишите в чат техподдержки, мы поможем.';
            if (stateForm.errorCode === 'INITIAL_PERIOD_STILL_ACTIVE') {
                errorText = 'Минимальный срок использования пакета каналов - 30 дней. Пакет можно отключить по истечении этого времени. Если остались вопросы, напишите в чат техподдержки.';
            } else if (stateForm.errorCode === 'DEACTIVATION_DATE_ALREADY_SET') {
                errorText = `Невозможно отключить пакет каналов будущей датой - дата отключения уже установлена. ${(dateToString !== '') ? `Пакет каналов будет отключен ${dateToString}` : ''}`;
            } else if (stateForm.errorCode === 'CANT_DEACTIVATE_SPECIAL_OFFER') {
                errorText = 'Невозможно отключить пакет каналов, подключенный по рекламной акции. Если остались вопросы, напишите в чат техподдержки.';
            } else if (stateForm.errorCode === 'PACKET_NOT_ACTIVE') {
 errorText = 'Пакет не является активным. Отключение не требуется';
}
        } else if (stateForm.action === 'on') {
            errorText = 'Возникла ошибка при возобновлении пакета каналов. Напишите в чат техподдержки, мы поможем.';
            if (stateForm.errorCode === 'PACKET_ALREADY_ACTIVE') {
                errorText = 'Пакет каналов уже подключен';
            }
        }
        content = (
            <React.Fragment>
                <Icon src={IconError} alt='Error'/>
                <CenterBlock>
                    <Title>Произошла ошибка ...</Title>
                    <Text> {errorText} </Text>
                </CenterBlock>
                <ButtonWrapper>
                    <Button type='primary' text='Написать в чат' onClick={onErrorClick}/>
                </ButtonWrapper>
            </React.Fragment>
        );
    }

    if (stateForm.isSuccess === true) {
        const text = stateForm.action === 'on' ? 'Пакет каналов успешно возобновлен' : 'Пакет каналов успешно отключен';
        content = (
            <React.Fragment>
                <Icon src={IconSuccess} alt='Success'/>
                <CenterBlock> <Title> {text} </Title> </CenterBlock>
                <ButtonWrapper>
                    <Button type='primary' text='Спасибо' onClick={onClose}/>
                </ButtonWrapper>
            </React.Fragment>
        );
    }

    return (
        <Wrapper>
            {content}
        </Wrapper>
    );
};

const mapStateToProps = ({ city, auth }) => ({
    billingHost: selectHostname({ auth, city }),
    auth,
});

const mapDispatchToProps = (dispatch) => ({
    openChat: () => dispatch(openChat())
});

export default connect(mapStateToProps, mapDispatchToProps)(ResumptionControl);
